import React from "react";

// Importing images directly
import icon1 from "./icons/icon-1.png";
import icon2 from "./icons/icon-2.png";
import icon3 from "./icons/icon-3.png";
import icon5 from "./icons/icon-5.png";
import icon4 from "./icons/icon-4.png";
import icon6 from "./icons/icon-6.png";
import icon7 from "./icons/icon-7.png";
import icon8 from "./icons/icon-8.png";
import icon9 from "./icons/icon-9.png";
import icon10 from "./icons/icon-10.png";
import icon11 from "./icons/icon-11.png";
import icon12 from "./icons/icon-12.png";


const Working = () => {
  return (
    <section className="work-category mx-auto max-w-[120em] py-24   px-10 md:px-16 w-full ">
      <div className="container mx-auto">
        <div className="flex xl:gap-20 gap-5 md:gap-10 flex-col xl:flex-row  ">
          <div className="w-full xl:w-1/3 flex items-center">
            <div className="common-heading  text-center xl:text-left">
              <span className="text-base md:text-lg font-semibold uppercase tracking-wider text-pink-600">
                Industries we work for
              </span>
              <h2 className="mb-8 text-3xl md:text-3xl lg:text-5xl font-bold">
                Helping Businesses in All Domains
              </h2>
              <p className=" ">
                At Versai Tech Solutions, we specialize in a wide range of
                domains to provide customized solutions for our clients. Our
                expertise includes Social Networking platforms that enhance
                community engagement, Digital Marketing strategies that boost
                brand visibility, and Ecommerce Development for seamless online
                shopping experiences. We also focus on the Tour & Travel sector,
                Digitalization of Business for streamlined operations, and
                Enterprise Services that support growth. Partner with us to
                unlock new opportunities and elevate your business.
              </p>
            </div>
          </div>
          <div className="w-full xl:w-2/4 2xl:w-2/3">
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {workCards.map((card, index) => (
                <div
                  key={index}
                  className={`icon-set transition-transform hover:scale-105 duration-300 ${card.bgColor} p-6 md:p-10 shadow-lg`}
                  style={{
                    animationDelay: `${0.2 * (index + 1)}s`,
                    borderRadius: "20% 0 20% 0",
                  }}
                >
                  <div className="work-card flex flex-col items-center">
                    <div className="icon-bg mb-4">
                      <img
                        src={card.icon}
                        alt={card.title}
                        className="w-10 h-10 md:w-12 md:h-12"
                      />
                    </div>
                    <p className="text-sm md:text-base">{card.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Array with imported images
const workCards = [
  { title: 'Social Networking', icon: icon1, bgColor: 'bg-[#70e4e8]' },
  { title: 'Digital Marketing', icon: icon2, bgColor: 'bg-[#f5eb92]' },
  { title: 'Ecommerce Development', icon: icon3, bgColor: 'bg-[#a3ffe2]' },
  { title: 'Video Service', icon: icon4, bgColor: 'bg-[#ffbc7a]' },
  { title: 'Banking Service', icon: icon5, bgColor: 'bg-[#e3ff8e]' },
  { title: 'Enterprise Service', icon: icon6, bgColor: 'bg-[#ffa0c6]' },
  { title: 'Education Service', icon: icon7, bgColor: 'bg-[#f3a6ff]' },
  { title: 'Tour and Travels', icon: icon8, bgColor: 'bg-[#97ffaf]' },
  { title: 'Health Service', icon: icon9, bgColor: 'bg-[#6cfffa]' },
  { title: 'Event & Ticket', icon: icon10, bgColor: 'bg-[#77baff]' },
  { title: 'Restaurant Service', icon: icon11, bgColor: 'bg-[#ffefd4]' },
  { title: 'Business Consultant', icon: icon12, bgColor: 'bg-[#7affdb]' }
];

export default Working;
